import { openCookieSettings } from "../lib/cookieConsent";

// Plain-language cookie policy. Lists the cookie categories the site uses and
// links to the live "Cookie settings" control (reopens the consent bar).
export default function CookiePolicy() {
  return (
    <div className="mx-auto max-w-3xl px-5 py-16 font-serif text-[#2a1a12]">
      <h1 className="text-3xl text-[#5a0000]">Cookie Policy</h1>
      <p className="mt-2 text-sm text-[#7a6754]">
        AvdheshanandG Mission — how we use cookies and your choices.
      </p>

      <div className="mt-8 space-y-6 text-[15px] leading-7 text-[#3d2b20]">
        <p>
          Cookies are small files stored on your device. We use them to keep the website working
          and, only with your consent, to understand how it is used. You are always in control and
          can change your choice at any time.
        </p>

        <section>
          <h2 className="text-xl text-[#9d1f1c]">1. Essential cookies (always on)</h2>
          <p className="mt-2">
            Needed for the site to function — page navigation, security, remembering your cookie
            choice and your language selection. These do not require consent and cannot be switched
            off.
          </p>
        </section>

        <section>
          <h2 className="text-xl text-[#9d1f1c]">2. Analytics cookies (your consent)</h2>
          <p className="mt-2">
            With your permission we use Google Analytics (via Google Tag Manager) to see which pages
            are visited and how the site performs, so we can improve it. These load only after you
            accept — if you reject or do nothing, no analytics cookies are set.
          </p>
        </section>

        <section>
          <h2 className="text-xl text-[#9d1f1c]">
            3. Marketing / data-sharing cookies (your consent)
          </h2>
          <p className="mt-2">
            We use the Meta (Facebook) Pixel to understand which of our appeals reach people, and to
            reach devotees on Facebook and Instagram. It records the pages you visit on this site
            and shares that with Meta. It stays off unless you turn it on, and turning it off again
            stops it immediately.
          </p>
        </section>

        <section>
          <h2 className="text-xl text-[#9d1f1c]">4. Embedded content</h2>
          <p className="mt-2">
            Event pages may embed videos from YouTube in privacy-enhanced mode. YouTube may set
            cookies if you play a video; please see Google&rsquo;s own privacy notice for details.
          </p>
        </section>

        <section>
          <h2 className="text-xl text-[#9d1f1c]">5. Changing your choices</h2>
          <p className="mt-2">You can review or change your consent at any time:</p>
          <button
            type="button"
            onClick={openCookieSettings}
            className="mt-3 rounded-md bg-[#5a0000] px-5 py-2.5 text-sm font-medium text-[#f5c45e] transition hover:bg-[#8a0000]"
          >
            Open cookie settings
          </button>
        </section>

        <section>
          <h2 className="text-xl text-[#9d1f1c]">6. Your rights &amp; contact</h2>
          <p className="mt-2">
            Depending on where you live (UK/EU GDPR, India&rsquo;s DPDP Act, or US state laws) you
            have rights over your personal data, including access and erasure. To exercise them, or
            for any privacy question, contact us at{" "}
            <a
              href="mailto:office@avdheshanandgmission.org"
              className="text-[#5a0000] underline-offset-2 hover:underline"
            >
              office@avdheshanandgmission.org
            </a>
            . See also our{" "}
            <a href="/privacy-policy" className="text-[#5a0000] underline-offset-2 hover:underline">
              Privacy Policy
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
